module.exports = __webpack_public_path__ + "5d627cd7920b10e23f30bb90ef3e110a.png";